import React, { useContext, useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from "react-router-dom";
import { IoSend } from "react-icons/io5";
import { FaSearch, FaArrowLeft } from "react-icons/fa";
import { LoginContext } from "../../../context/LoginContext"
import axios from 'axios';
import defaultImage from '../others-profiles/default.webp'
import { toAbsolute, getPrimaryUserImage } from '../../../utils/userImages';
import { MessageContext } from "../../../context/MessageContext.js"
import { notifyMessagesChanged, formatBadgeCount } from '../../../utils/messageEvents';
import './ChatUI.css';
import 'bootstrap/dist/css/bootstrap.min.css';

const ChatApp = () => {

  const { userData, userId, isLoggedIn, isPremium } = useContext(LoginContext);
  const { messageUserData, messageName, messageUserId, isMessage, setMessageName, setMessageUserData, setMessageUserId, setIsMessage } = useContext(MessageContext);
  const param = useParams();
  const navigate = useNavigate();
  const [message, setMesssage] = useState([]);
  const [connUser, setConnUsers] = useState([]);
  const [newMessage, setNewMessage] = useState(null);
  const [chatUserName, setChatUserName] = useState("Guest user");
  const [profilePicture, setProfilePicture] = useState(defaultImage);
  const [error, setError] = useState(true);
  const [connId, setConnId] = useState(undefined);
  const [searchName, setSearchName] = useState('');
  const [limitError, setLimitError] = useState("");

  const payload = new FormData();
  payload.append("id", userId);
  payload.append("looking", userData.looking_for);
  payload.append("gender", userData.gender);
  payload.append("status", userData.status);
  payload.append("email", userData.email);





  const fetchMessages = (connId) => {

    payload.append("msg_id", connId);
    if (connId) {
      axios.post(`${process.env.REACT_APP_API_BASE_URL}message_controller/message`, payload)
        .then(response => {
          if (response.data.response === 'success') {
            setMesssage(response.data.data);
            notifyMessagesChanged();
          }
        })
        .catch(error => {
          console.error("There was an error fetching users!", error);
        });
    } else {
      console.log("msg_id Not Set");
    }
  }


  const fetchUsers = () => {

    axios.post(`${process.env.REACT_APP_API_BASE_URL}message_controller/messageUser`, payload)
      .then(response => {
        if (response.data.response === 'success') {
          setConnUsers(response.data);
          if (param.id != undefined && Array.isArray(response.data.data)) {

            if (response.data.data.find(user => { return (user.mesg_to === param.id) ? (user.mesg_to == param.id) : (user.mesg_from == param.id) })) {

              //////check user seen
              setConnId(response.data.data.find(user => { return (user.mesg_to === param.id) ? (user.mesg_to == param.id) : (user.mesg_from == param.id) }).user_id);

              setChatUserName(response.data.data.find(user => { return (user.mesg_to === param.id) ? (user.mesg_to == param.id) : (user.mesg_from == param.id) }).name);
              const activeUserMatch = response.data.data.find(user => { return (user.mesg_to === param.id) ? (user.mesg_to == param.id) : (user.mesg_from == param.id) });
              setProfilePicture(toAbsolute(activeUserMatch?.image1) || defaultImage);

              fetchMessages(response.data.data.find(user => { return (user.mesg_to === param.id) ? (user.mesg_to == param.id) : (user.mesg_from == param.id) }).user_id);
            }

          }
          if (response.data.data.some(user => user.mesg_to == param.id)) {
            setMessageUserData({});
            setMessageName("Hii Guest");
            setMessageUserId(null);
            setIsMessage(false);
          }
        } else {
          setConnUsers([]);
        }
      })
      .catch(error => {
        console.error("There was an error fetching users!", error);
      });

    if (param.id != messageUserId) {
      setMessageUserData({});
      setMessageName("Hii Guest");
      setMessageUserId(null);
      setIsMessage(false);
    }

  }



  useEffect(() => {
    if (!isLoggedIn) {
      navigate("/login");
    }

    if (param.id != userId) {
      setConnId(param.id);
      fetchUsers();
      fetchMessages(param.id);
    }

    const interval = setInterval(() => {
      console.log(param.id);
      fetchMessages(param.id);
    }, 1000 * 60 * 1); 

    return () => clearInterval(interval); 

    ///useeffect()
  }, [param.id]);

  const ValiddateInput = () => {
    if (newMessage != "" && newMessage != null && newMessage.trim().length > 0 && newMessage) {
      setError(false);
      return true;
    } else {
      setError(true);
      return false;
    }
  }


  const handleInput = (e) => {
    if (e.target.value != "" && e.target.value != null && e.target.value.trim().length > 0 && e.target.value) {
      setError(false);
    } else {
      setError(true);
    }
    setNewMessage(e.target.value);
  }


  const handleMessageSubmit = () => {
    if (!ValiddateInput()) return;
    if (!isPremium) {
      navigate(`/upgrade/${userId}`);
      return;
    }

    const payload = new FormData();
    payload.append("id", userId);
    payload.append("looking", userData.looking_for);
    payload.append("gender", userData.gender);
    payload.append("status", userData.status);
    payload.append("email", userData.email);
    payload.append("msg_to", connId);
    payload.append("msg", newMessage);
    const outgoing = newMessage;
    setNewMessage("");
    setError(true);
    setLimitError("");
    axios.post(`${process.env.REACT_APP_API_BASE_URL}message_controller/sendMessage`, payload)
      .then(response => {
        if (response.data.response === 'success') {
          fetchMessages(connId);
          fetchUsers();
          setMessageName(null);
          setError(true);
        } else if (response.data.response === 'limit' || response.data.response === 'upgrade') {
          setNewMessage(outgoing);
          setLimitError(response.data.message || 'Daily message limit reached');
          if (response.data.response === 'upgrade') {
            navigate(`/upgrade/${userId}`);
          }
        } else {
          setNewMessage(outgoing);
          setLimitError(response.data.message || 'Message not sent');
        }
      })
      .catch(error => {
        setNewMessage(outgoing);
        console.error("There was an error fetching users!", error);
      });
  }



  const hasActiveChat = param.id != undefined && param.id !== 'undefined';
  const filteredContacts = connUser?.data?.filter(user =>
    user.name.toLowerCase().includes(searchName.toLowerCase())
  ) || [];
  const showContextUser =
    isMessage &&
    messageUserId &&
    !filteredContacts.some(
      (u) =>
        String(u.user_id) === String(messageUserId) ||
        String(u.mesg_to) === String(messageUserId) ||
        String(u.mesg_from) === String(messageUserId)
    );

  return (
    <div className="container chat-page-wrap mt-3 mt-md-5 mb-3 mb-md-5 px-2 px-md-3">

      <div className={`chat-app ${hasActiveChat ? 'mobile-chat-open' : ''}`}>
        <div className="row g-0">
          {/* Sidebar */}
          <div className="col-12 col-md-4 chat-sidebar p-3">
            <h6 className="mb-3 chat-panel-title">Chat Messages</h6>
            <div className="input-group mb-3 chat-search">
              <input
                type="text"
                value={searchName}
                onChange={(e) => setSearchName(e.target.value)}
                placeholder="Search chats"
                className="form-control"
              />
              <span className="input-group-text bg-white">
                <FaSearch />
              </span>
            </div>

            <div className="chat-user-list">
              {showContextUser && (
                <Link to={`/chat/${messageUserId}`}>
                  <div className="chat-user selected">
                    <img
                      src={getPrimaryUserImage(messageUserData) || (messageUserData.image1 ? toAbsolute(messageUserData.image1) : defaultImage)}
                      className="chat-avatar"
                      alt={messageName}
                    />
                    <div className="flex-grow-1 ms-2">
                      <strong>{messageName}</strong>
                    </div>
                  </div>
                </Link>
              )}

              {filteredContacts.map((res) => {
                const chatPartnerId = res.user_id === res.mesg_from ? res.mesg_from : res.mesg_to;
                const isSelected = String(res.mesg_to) === String(param.id) || String(chatPartnerId) === String(param.id);
                return (
                  <Link
                    key={`${res.user_id}-${res.mesg_from}-${res.mesg_to}`}
                    onClick={() => {
                      setConnId(res.user_id === res.mesg_from ? res.mesg_from : res.mesg_to);
                    }}
                    to={`/chat/${res.user_id === res.mesg_from ? res.mesg_from : res.mesg_to}`}
                  >
                    <div className={`chat-user ${isSelected ? 'selected' : ''}`}>
                      <img
                        src={getPrimaryUserImage(res) || (res.image1 ? toAbsolute(res.image1) : defaultImage)}
                        className="chat-avatar"
                        alt={res.name}
                      />
                      <div className="flex-grow-1 ms-2 chat-user-text">
                        <strong>{res.name}</strong>
                        <p className="text-truncate">{res.message}</p>
                      </div>
                      <div className="text-end chat-user-meta">
                        <span className="time d-block">{res.date}</span>
                        {!isSelected && connUser?.msgCount?.filter((item) => item.mesg_from === res.mesg_from).map((d) => (
                          <span key={d.mesg_from} className="badge rounded-pill bg-danger text-white mt-1" aria-label={`${d.no_msg} unread`}>{formatBadgeCount(Number(d.no_msg) || 0)}</span>
                        ))}
                      </div>
                    </div>
                  </Link>
                );
              })}

              {filteredContacts.length === 0 && !showContextUser && (
                <p className="text-muted text-center small py-4 mb-0">No conversations yet.</p>
              )}
            </div>
          </div>


          {/* Chat Window */}
          <div className="col-12 col-md-8 chat-window d-flex flex-column">

            {hasActiveChat ? (<>
              <div className="chat-header p-3 d-flex align-items-center">
                <button
                  type="button"
                  className="chat-back-btn d-md-none me-2"
                  aria-label="Back to chats"
                  onClick={() => navigate('/chat')}
                >
                  <FaArrowLeft />
                </button>
                <div className="d-flex align-items-center flex-grow-1 min-w-0">
                  <img
                    src={(isMessage) ? (getPrimaryUserImage(messageUserData) || toAbsolute(messageUserData.image1) || defaultImage) : (profilePicture || defaultImage)}
                    className="rounded-circle me-2 chat-header-avatar"
                    alt="User"
                  />
                  <div className="min-w-0">
                    <strong className="d-block text-truncate">{(isMessage) ? messageName : chatUserName}</strong>
                    <p className="online-status mb-0">Recently Online</p>
                  </div>
                </div>
              </div>
              <div className="chat-body flex-grow-1 p-3 d-flex flex-column">
                {message?.length ? message.map((res, idx) => (
                  <div
                    key={`${res.mesg_from}-${res.time}-${idx}`}
                    className={`chat-bubble align-self-${(res.mesg_from === userId) ? 'end' : 'start'} ${(res.mesg_from === userId) ? 'sent' : 'received'}`}
                  >
                    <span className="chat-bubble-text">{res.message}</span>
                    <span className={`messagetime ${(res.mesg_from === userId) ? 'text-white' : 'text-muted'}`}>{res.time}</span>
                  </div>
                )) : (
                  <p className="text-muted text-center my-auto small">Say hello — send your first message.</p>
                )}
              </div>
              <div className="chat-footer p-3">
                {limitError && (
                  <div className="alert alert-warning py-2 mb-2" role="alert">{limitError}</div>
                )}
                <div className="d-flex align-items-center gap-2">
                  <input
                    type="text"
                    className="form-control"
                    value={newMessage ?? ''}
                    onChange={handleInput}
                    onKeyDown={(e) => e.key === 'Enter' && handleMessageSubmit()}
                    placeholder="Send a message"
                  />
                  <button type="button" onClick={handleMessageSubmit} className="btn btn-danger chat-send-btn" disabled={error}>
                    <IoSend />
                  </button>
                </div>
              </div>
            </>) : (
              <div className="chat-empty-state d-none d-md-flex flex-column align-items-center justify-content-center flex-grow-1 p-4 text-muted">
                <p className="mb-0">Select a conversation to start chatting.</p>
              </div>
            )}


          </div>
        </div>
      </div >
    </div>
  );
};

export default ChatApp;
